<template>
  <!-- 经历库 -->
  <div class="library-main border-box" id="libraryWrapper" @click.stop>
    <div class="library-content">
      <div class="library-card-control">
        <!-- 当前简历不是我的简历（模板/大牛简历）-->
        <template v-if="!isMyselfResume && experienceListLength">
          <div class="library-title-active active">
            <span>使用经历快速生成</span>
          </div>
        </template>
        <template v-else>
          <div class="library-title-card" v-for="(item, index) in libraryCards" :class="{ 'active': libraryCardActive === index }" @click="changeLibraryCard(index)" :key="'library-card-' + index">
            <span>{{ item }}</span>
          </div>
          <div class="line" :style="{left: libraryCardActive === 0 ? '78px' : '183px'}"/>
        </template>
      </div>
      <!-- 标题 (不是我自己的简历才显示---我的简历平铺展开经历库) -->
      <div class="library-title" :style="{height: libraryCardActive === 0 ? '0px' : '76px'}">
        <template v-if="libraryCardActive === 0 && false">
          <div class="current-select-module reset-module-width" @click="changeSidebarState" v-if="experienceTitleList.length > 0">
            <div class="library-title-name">
              <span>{{currentExprienceModuleTitle || '未命名模块'}}</span>
<!--              <span v-if='currentExperience.length > 0'>({{currentExperience.length}}/{{ customType ? 50 : 30}})</span>-->
              <span v-if='currentExperience.length > 0'>({{currentExperience.length}}/50)</span>
              <i class="iconfont" :class="showLibrarySidebar ? 'iconshangla' : 'iconxiala'"></i>
            </div>
            <div class="library-sidebar" v-show="showLibrarySidebar">
              <div class="library-sidebar-item"
                   :class="[currentExperienceType.index == index ? 'active' : '', currentInfo.operation&& currentExperienceType.index !== index ?'disabled':'' ]"
                   v-for="(item, index) in experienceTitleList" :key="String(index)" @click="toggleTab(item,index)">
                <div class="ellipsis1 word_wrap_b">{{item.title || '未命名模块'}}</div>
                <!-- {{item && item.title || '未命名模块'}}  v-show="getShowMenu(item)" -->
              </div>
            </div>
          </div>
        </template>
        <!--        <button class="library-title-btn" :class="isEdit ? 'active' : ''" @click="isEdit = !isEdit" v-show="libraryCardActive === 0">-->
        <!--          <i class="iconfont iconsettings"></i>-->
        <!--          <span>{{isEdit ? '完成' : '管理'}}</span>-->
        <!--        </button>-->
        <template v-if="libraryCardActive === 1">
          <div class="current-select-module" @click="changeModuleSidebarState">
            <div class="library-title-name">
              <span>{{daniuModuleList[currentModule.index] && daniuModuleList[currentModule.index].title || '未命名模块'}}</span>
              <!--            <span v-if='currentExperience.length > 0'>({{currentExperience.length}}/{{ customType ? 50 : 30}})</span>-->
              <i class="iconfont" :class="showModuleSidebar ? 'iconshangla' : 'iconxiala'"></i>
            </div>
            <div class="library-sidebar" v-show="showModuleSidebar">
              <div class="library-sidebar-item"
                   :class="[currentModule.index == index ? 'active' : '', currentInfo.operation && currentModule.index !== index ?'disabled':'' ]"
                   v-for="(item, index) in daniuModuleList" :key="String(index)" @click="toggleModule(item,index)">
                <div class="ellipsis1 word_wrap_b">{{item.title || '未命名模块'}}</div>
                <!-- {{item && item.title || '未命名模块'}}  v-show="getShowMenu(item)" -->
              </div>
            </div>
          </div>
          <div class="current-select-module" @click="changeDaniuState">
            <div class="library-title-name">
              <span>{{daniuCurrentExperienceType.cn.replace(/简历模板/g,'')}}</span>
              <!--            <span v-if='currentExperience.length > 0'>({{currentExperience.length}}/{{ customType ? 50 : 30}})</span>-->
              <i class="iconfont" :class="daniuLibraryState ? 'iconshangla' : 'iconxiala'" />
            </div>
            <div class="library-sidebar" v-show="daniuLibraryState" :style="{left: 0}">
              <div class="library-sidebar-item"
                   v-for="(item, index) in daniuExperenceTitleList" :key="item.id" @click="toggleDniuJob(item,index)"
                   :class="[daniuCurrentExperienceType.id === item.id ? 'active' : '']">
                <div class="ellipsis1 word_wrap_b">{{item.cn.replace(/简历模板/g,'')}}</div>
                <!-- {{item && item.title || '未命名模块'}}  v-show="getShowMenu(item)" -->
              </div>
            </div>
          </div>
        </template>
      </div>
      <!-- 经历库内容，不是我的简历（模板或者大牛简历）显示旧版经历库内容 -->
      <template v-if="libraryCardActive === 0 && !isMyselfResume">
        <div class="library-list-content" :style="{height: `calc(100% - ${isEdit ? '0px' : '88px'} - 30px)`}">
          <!-- <template v-for="(opt, key) in menu"> -->
          <!-- :key="key" v-if="active == key" -->
          <div class="library-list" id="libraryScrollList">
            <template v-if="experienceListLength > 0">
              <template v-for="(experienceItem, experienceIndex) in getterExperienceTitle">
                <div class="library-title" :key="`experience_title_${experienceIndex}`" :style="{zIndex: experienceIndex + 10}">
                  <div class="current-select-module reset-module-width" @click="changeModuleCheck(experienceItem)">
                    <div class="library-title-name">
                      <span>{{experienceItem.title || '未命名模块'}}</span>
                      <!--                    <span v-if='currentExperienceItem(experienceItem.type).length > 0'>({{currentExperienceItem(experienceItem.type).length}}/{{ customType ? 50 : 30}})</span>-->
                      <span v-if='currentExperienceItem(experienceItem.type).length > 0'>({{currentExperienceItem(experienceItem.type).length}}/50)</span>
                      <i class="iconfont" :class="experienceItem.checked ? 'iconshangla' : 'iconxiala'"></i>
                    </div>
                  </div>
                </div>
                <div class="experience-container" :key="`experience_main_${experienceIndex}`" :style="{height: experienceItem.checked ? 'auto' : '0px'}">
                  <template v-if="experienceItem.type === 'extras'">
                    <template v-for="(items, index) in Object.keys(currentExperienceItem(experienceItem.type))">
                      <div class="other-title" :key="`experience_other_${index}`">{{getOtherTitle(items)}}</div>
                      <template v-for="(item, bKey) in currentExperienceItem(experienceItem.type)[items]">
                        <div class="library-item" :key="`not_my_resume_${items}_${bKey}`"
                             @click="selectOther(items, item, bKey, experienceItem.type)"
                             :class="[item.isSelect ? 'active' : '', currentInfo.operation?'disabled':'']">
                          <div class="library-item-select" v-if="!isEdit"></div>
                          <div class="library-item-content">
                            <div class="item-desc" v-html="item.description"
                                 v-if="item.description"></div>
                            <div class="item-date" v-if="item.updated_at">更新时间：{{timeFormatFilter(item.updated_at)}}</div>
                          </div>
                          <div class="library-item-delete library-item-delete-icon" @click.stop="deleteExperience(item, bKey, items, experienceItem.type, experienceIndex)">
                            <i class="iconfont icontrash-" />
                          </div>
                        </div>
                      </template>
                    </template>
                  </template>
                  <template v-else>
                    <div class="library-item" :class="[item.isSelect ? 'active' : '', currentInfo.operation?'disabled':'']"
                         v-for="(item, index) in currentExperienceItem(experienceItem.type)" :key="`not_my_resume_${index}`" @click="selectItem(item, index, experienceItem.type)">
                      <div class="library-item-select" v-if="!isEdit"></div>
                      <div class="library-item-content">
                        <template
                          v-if="currentExperienceType.type !== 'personal_summary' && currentExperienceType.type !== 'skill_list'">
                          <div class="item-name text-overflow" v-if="item.company || item.university || item.name">
                            {{item.company || item.university || item.name}}
                          </div>

                          <div class="item-info text-overflow"
                               v-if="currentExperienceType.type === 'edus' && (item.city || item.major || item.degree || item.uni_school)">
                            <span v-if="item.city">{{item.city}}</span>
                            <span v-if="item.major">{{item.major}}</span>
                            <span v-if="item.degree">{{item.degree}}</span>
                            <span v-if="item.uni_school">{{item.uni_school}}</span>
                          </div>
                          <div class="item-info text-overflow" v-else-if="item.city || item.title || item.dept">
                            <span v-if="item.city">{{item.city}}</span>
                            <span v-if="item.title">{{item.title}}</span>
                            <span v-if="item.dept">{{item.dept}}</span>
                          </div>

                          <div class="text-overflow" v-if="item.start_at || item.end_at || item.present">
                            <span v-if="item.start_at">{{moment(item.start_at).format('YYYY.MM')}}</span>
                            <span v-if="item.start_at && (item.end_at || item.present)"> - </span>
                            <span v-if="item.end_at">{{moment(item.end_at).format('YYYY.MM')}}</span>
                            <span v-if="item.present">{{item.present}}</span>
                          </div>
                        </template>
                        <div class="item-desc" v-if="item.description" v-html="item.description"></div>
                        <div class="item-date" v-if="item.updated_at">更新时间：{{timeFormatFilter(item.updated_at)}}</div>
                      </div>
                      <div class="library-item-delete library-item-delete-icon" @click.stop="deleteExperience(item, index, '', experienceItem.type, experienceIndex)"><i
                        class="iconfont icontrash-"></i></div>
                    </div>
                  </template>
                </div>
              </template>
            </template>
            <template v-else>
              <no-data tooltip="暂无经历" />
            </template>
          </div>
          <!-- </template> -->
        </div>
        <!-- 按钮 -->
        <div class="library-btn" v-if="!isEdit">
          <!-- <div class="library-all active" v-if="!editModuleData.show">
            <div class="library-all-select"></div>全选
          </div> -->
          <div class="btn">
            <button @click="close">取消</button>
            <button class="active" :class="[!getExperienceAllLength ? 'disabled' : '' ]" @click="debounceSubmit">确定</button>
          </div>
        </div>
      </template>
      <template v-if="libraryCardActive === 1">
        <div class="library-list-content" :style="{height: `calc(100% - 128px)`}" v-loading="loadingFlag">
          <!-- <template v-for="(opt, key) in menu"> -->
          <!-- :key="key" v-if="active == key" -->
					<!-- :style="`overflow: ${ loadingFlag ? 'hidden' : 'auto' }`" -->
          <div class="library-list" id="libraryScrollList" @scroll="scrollEvent" >
<!--            <template style="position:absolute;left:0;top:0;">-->
<!--              <Skeleton :options="{moduleCount: 5, count: 4}" backgroundColor="#F5F6FA" :isEditor="true" v-if="loadingFlag"/>-->
<!--            </template>-->
            <template v-if="daniuCurrentExperience.data && daniuCurrentExperience.data.length > 0">
              <div class="library-item" :class="[item.isSelect ? 'active' : '', currentInfo.operation?'disabled':'']"
                   v-for="(item, index) in daniuCurrentExperience.data" :key="index">
                <!--                <div class="library-item-select" v-if="!isEdit"></div>-->
                <div class="library-item-content">
                  <template
                    v-if="currentExperienceType.type !== 'personal_summary' && currentExperienceType.type !== 'skill_list'">
                    <div class="item-name text-overflow copy-item" v-if="item.company || item.university || item.name">
                      {{item.company || item.university || item.name}}
                    </div>

                    <div class="item-info text-overflow"
                         v-if="currentExperienceType.type === 'edus' && (item.city || item.major || item.degree || item.uni_school)">
                      <span v-if="item.city">{{item.city}}</span>
                      <span v-if="item.major">{{item.major}}</span>
                      <span v-if="item.degree">{{item.degree}}</span>
                      <span v-if="item.uni_school">{{item.uni_school}}</span>
                    </div>
                    <div class="item-info text-overflow" v-else-if="item.city || item.title || item.dept">
                      <span v-if="item.city">{{item.city}}</span>
                      <span v-if="item.title">{{item.title}}</span>
                      <span v-if="item.dept">{{item.dept}}</span>
                    </div>

                    <div class="text-overflow" v-if="item.start_at || item.end_at || item.present">
                      <span v-if="item.start_at">{{moment(item.start_at).format('YYYY.MM')}}</span>
                      <span v-if="item.start_at && (item.end_at || item.present)"> - </span>
                      <span v-if="item.end_at">{{moment(item.end_at).format('YYYY.MM')}}</span>
                      <span v-if="item.present">{{item.present}}</span>
                    </div>
                  </template>
                  <div class="item-desc" v-if="item.description" v-html="item.description"></div>
<!--                  <div class="item-date" v-if="item.updated_at">更新时间：{{timeFormatFilter(item.updated_at)}}</div>-->
                </div>
                <div class="library-item-delete library-item-copy" @click.stop="copyExperience(item, index)" v-show="item.description">
                  复制
                  <!--                  <i class="iconfont icontrash-"></i>-->
                </div>
              </div>
            </template>
            <template v-if="!loadingFlag && (!daniuCurrentExperience.data || !daniuCurrentExperience.data.length)">
              <no-data tooltip="暂无经历" />
            </template>
          </div>
          <!-- </template> -->
        </div>
      </template>
      <template v-if="libraryCardActive === 0 && isMyselfResume">
        <div class="library-list-content" :style="{height: `calc(100% - 65px)`}">
          <div class="library-list" id="libraryScrollList">
            <template v-if="experienceListLength">
              <template v-for="(experienceItem, experienceIndex) in getterExperienceTitle">
                <div class="library-title" :key="`experience_title_${experienceIndex}`" :style="{zIndex: experienceIndex + 10}">
                  <div class="current-select-module reset-module-width" @click="changeModuleCheck(experienceItem)">
                    <div class="library-title-name">
                      <span>{{experienceItem.title || '未命名模块'}}</span>
                      <!--                    <span v-if='currentExperienceItem(experienceItem.type).length > 0'>({{currentExperienceItem(experienceItem.type).length}}/{{ customType ? 50 : 30}})</span>-->
                      <span v-if='currentExperienceItem(experienceItem.type).length > 0'>({{currentExperienceItem(experienceItem.type).length}}/50)</span>
                      <i class="iconfont" :class="experienceItem.checked ? 'iconshangla' : 'iconxiala'"></i>
                    </div>
                  </div>
                </div>
                <div class="experience-container" :key="`experience_main_${experienceIndex}`" :style="{height: experienceItem.checked ? 'auto' : '0px'}">
                  <template v-if="experienceItem.type === 'extras'">
                    <template v-for="(item, index) in Object.keys(currentExperienceItem(experienceItem.type))">
                      <div class="other-title" :key="`experience_other_${index}`">{{getOtherTitle(item)}}</div>
                      <template v-for="(bItem, bKey) in currentExperienceItem(experienceItem.type)[item]">
                        <ExperienceCard
                          :bKey="item"
                          :index="bKey"
                          :isEdit="isEdit"
                          :otherTitle="otherTitle"
                          :currentInfo="currentInfo"
                          :type="experienceItem.type"
                          :itemData="bItem"
                          :experienceIndex="experienceIndex"
                          @deleteExperience="deleteExperience"
                          @selectExperience="selectExperience" />
                      </template>
                    </template>
                  </template>
                  <template v-else>
                    <template v-for="(item, index) in currentExperienceItem(experienceItem.type)">
                      <ExperienceCard
                        :index="index"
                        :isEdit="isEdit"
                        :otherTitle="otherTitle"
                        :currentInfo="currentInfo"
                        :type="experienceItem.type"
                        :experienceIndex="experienceIndex"
                        :key="`experience_data_${index}`"
                        :itemData="item"
                        @deleteExperience="deleteExperience"
                        @selectExperience="selectExperience" />
                    </template>
                  </template>
                </div>
              </template>
            </template>
            <template v-else>
              <no-data tooltip="暂无经历" />
            </template>
          </div>
        </div>
      </template>
    </div>
    <LibraryHoverBox v-if="showJobTabCardDialog || showJobTabCardDialogSelf" @deleteExperience="deleteExperience" @selectExperience="selectExperience" />
  </div>
</template>
<script>
	import api from '@/api'
  import NoData from '@/components/NoData/index'
	import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
	import moment from 'moment'
	import { timeFormatFilter, debounce, copyToClip } from '@/assets/js/util'
  import Skeleton from '@/components/base/skeleton';
  import ExperienceCard from '../ExperienceCard'
  import LibraryHoverBox from "../LibraryHoverBox";

	export default {
		name: 'library',
    components: {
		  NoData,
      Skeleton,
      ExperienceCard,
      LibraryHoverBox
    },
    props: {
      // 经历库数量
      // experienceListLength: {
      //   type: Number,
      //   default: 0
      // }
    },
		data () {
			return {
				moment,
				timeFormatFilter,
				active: 0,
				isEdit: false,
				menu: [], // 菜单
				// 默认标题
				otherTitle: {
					certificate: '证书/执照：',
					interest: '兴趣爱好：',
					language: '语言能力：',
					other: '活动项目：',
					skill: '技能：',
				},
				newCvInfo: {}, // 新版cvinfo
				debounceSubmit: null,
				isSubmit: false,
				showLibrarySidebar: false,
        libraryCardActive: 0,    // 经历库 card 分类高亮控制
        libraryCards: [
          '我的经历',
          '大牛经历'
        ],   // 经历库 card 数组
        daniuLibraryState: false,   // 经历库大牛经历下拉选择框控制
        daniuJobs: [],  // 大牛经历下拉框数据
        scrollLock: false,    // 滚动监听锁定（防止多次触发）
        showModuleSidebar: false,   // 大牛经历模块开关
        getterExperienceTitle: [],  // 所有模块标题（自己的简历编辑状态）
			}
		},
    watch: {
      libraryState: {
        handler(val) {
          if (!this.isMyselfResume && this.experienceListLength === 0) {
            this.libraryCardActive = 1
          }
        }
      },
      experienceTitleList: {
        deep: true,
        handler(val, oldVal) {
          let newVal = JSON.parse(JSON.stringify(val))
          this.getterExperienceTitle = newVal.map(item => {
            item.checked = true;
            return item
          })
        }
      }
    },
		computed: {
			...mapState('cvsEditor', [ 'cvToken', 'cvInfo', 'list', 'experience', 'edidModuleData' ]),
			...mapState('editor', [ 'cvToken', 'cvDetail', 'currentInfo', 'works', 'orgs', 'edus', 'isMyselfResume', 'showJobTabCardDialog', 'showJobTabCardDialogSelf', 'libraryState' ]),
			...mapState('experience', [ 'backUpExperienceList', 'experienceList', 'currentExperienceType', 'experienceTitleList', 'daniuExperenceTitleList', 'daniuCurrentExperienceType', 'currentModule', 'daniuModuleList', 'loadingFlag', 'sidebarOption' ]),
			...mapGetters('experience', [ 'currentExperience', 'daniuCurrentExperience', 'experienceListLength' ]),
			//获取所有模块总选中长度
			getExperienceAllLength () {
				let length = 0
				let { submodule_info } = this.cvDetail
				if (!submodule_info.sections_position) {
					return 0
				}
				Object.keys(this.experienceList).forEach(key => {
					length += this.filterItemCheck(this.experienceList[key], key).length
				})
				return length
			},
			customType () {
				const types = [ 'edus', 'orgs', 'works', 'extras' ]
				return !types.includes(this.currentExperienceType.type)
			},
      currentExprienceModuleTitle(){
        let index = this.experienceTitleList.findIndex(item => item.type == this.currentExperienceType.type);
        if(index > -1){
          return this.experienceTitleList[index].title;
        }else {
          return null;
        }
      }
		},
		created () {
			this.debounceSubmit = debounce(this.submit, 300)
		},
		methods: {
			...mapMutations('experience', [ 'updateCurrentExperienceType', 'updateExperienceList', 'updateBackUpExperienceList', 'updateSidebarOption', 'updateExperienceTitleList', 'updateCurrentModule' ]),
			...mapMutations('editor', [ 'setCvDetail', 'setModuleData', 'updateLibraryState', 'setJobTabScrollActive', 'setJobTabCardContentScrollY', 'setShowJobTabCardDialogData' ]),
			...mapActions('editor', [ 'createCvDetail', 'getCheckData', ]),
			...mapActions('manage', [ 'getMenuList', ]),
      ...mapActions('experience', ['updateDaniuCurrentType', 'getDaniuExperienceList', 'getLimitDaniuExperience']),
      // 选择同步当前的经历
      selectExperience(item, index, otherKey, type, experienceIndex) {
        // this.updateCurrentExperienceType({type: type, index: experienceIndex})
        if (otherKey) {
          this.selectOther(otherKey, item, index, type, experienceIndex)
        } else {
          this.selectItem(item, index, type, experienceIndex)
        }
      },
      // 获取当前模块下的经历数量
      currentExperienceItem(type) {
        return this.experienceList[type]
      },
      // 修改收起状态
      changeModuleCheck(obj) {
        this.getterExperienceTitle = this.getterExperienceTitle.map(item => {
          if (item.title === obj.title && item.type === obj.type) {
            item.checked = !obj.checked
          }
          return item
        })
      },
      // 复制大牛经历
      copyExperience(item, index) {
			  if (item.description) {
          copyToClip(item.description.replace(/<ul>|<\/ul>|<li>|<\/li>/g,''), () => {
            this.$message.success('复制成功')
          })
        }
      },
      // 滚动监听
      scrollEvent() {
        // 可存this指向
        const appThis = this
        document.getElementById('libraryScrollList').addEventListener('scroll', function () {
          // scrollHeight: 内容区域的总高度    clientHeight: 内容可视区域的高度     scrollTop: 滚动距离顶部的位置
          // 总高度减距离顶部的距离再减5判断是否小于可视区域的高度
          if (parseInt(this.scrollHeight - this.scrollTop - 5) <= this.clientHeight && !appThis.scrollLock) {
            appThis.scrollLock = true
            console.log('到底部了')
            let { data, pages, page_count } = appThis.daniuCurrentExperience
            if (pages < page_count) {
              appThis.getLimitDaniuExperience({ page: pages + 1, cvDetail: appThis.cvDetail })
            }
            setTimeout(() => {
              appThis.scrollLock = false
            },3000)
          }
        })
      },
      // 切换经历库 title
      changeLibraryCard(index) {
			  this.libraryCardActive = index
      },
			changeSidebarState () {
				this.showLibrarySidebar = !this.showLibrarySidebar
			},
      changeModuleSidebarState() {
			  this.showModuleSidebar = !this.showModuleSidebar
        if (this.showModuleSidebar) {
          this.daniuLibraryState = false
        }
      },
      changeDaniuState() {
			  this.daniuLibraryState = !this.daniuLibraryState
        if (this.daniuLibraryState) {
          this.showModuleSidebar = false
        }
      },
			//检测当前模块是否有子经历
			// getShowMenu(data) {
			//   // console.log(data)
			//   // if (data.key === 'extras') {
			//   //   for (let key in data.others) {
			//   //     if (data.others[key].length) return true;
			//   //   }
			//   //   return false;
			//   // }
			//   // else {
			//   //   return data.infos && data.infos.length;
			//   // }
			//   return true;
			// },
			// 获取other模块标题
			getOtherTitle (type) {
				let key = type.substring(0, type.length - 1)
				// this.cvDetail.submodule_info[key + '_title'] ||
				return this.otherTitle[key]
			},
			// 取消
			async close () {
				//把备份数据同步到当前经历库数据中
				this.updateExperienceList(JSON.parse(JSON.stringify(this.backUpExperienceList)))
				//当前右侧大tab选择类型置为空
				// this.updateSidebarOption('library')
        // 关闭经历库
        this.updateLibraryState(false)
			},
			// 删除经历
			async deleteExperience (item, index, otherKey, type, experienceIndex) {
        this.updateCurrentExperienceType({type: type, index: experienceIndex})
				const alertData = {
					show: true,
					type: 'message',
					messageTitle: '经历删除提示',
					showCancelButton: true, //取消按钮
					showConfirmButton: true, // 确定按钮
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					confirmButtonClass: 'cvs-edit-cancelButtonClass',
					cancelButtonClass: 'cvs-edit-confirmButtonClass',
					messageContent: `
          <p>删除后将无法恢复，是否确认删除？</p>
        `,
					cancel: close => {
						close()
					},
					confirm: async close => {
						close()
						this.deleteApi(item, index, otherKey, type)
					}
				}
				this.$store.dispatch('app/setAlertData', alertData)
			},
			// 删除经历接口逻辑
			async deleteApi (item, index, otherKey, moduleType) {
				//otherKey 如果有就是其他，返回的是其他里边的小模块
				let experienceList = JSON.parse(JSON.stringify(this.experienceList))
				let backUpExperienceList = JSON.parse(JSON.stringify(this.backUpExperienceList))
				let experienceTitleList = JSON.parse(JSON.stringify(this.experienceTitleList))
				// let { type } = this.currentExperienceType.type
        let type = moduleType || this.currentExperienceType.type
				try {
					let res = {}
					if (type === 'edus') {
						res = await api.cvsEditor.deleteEdu(item.id, {}, { cv_token: this.cvToken })
					} else if (type === 'works') {
						res = await api.cvsEditor.deleteWork(item.id, {}, { cv_token: this.cvToken })
					} else if (type === 'orgs') {
						res = await api.cvsEditor.deleteOrg(item.id, {}, { cv_token: this.cvToken })
					} else if (otherKey) {
						// other数据
						let keyTitle = otherKey.substring(0, otherKey.length - 1) + '_id'
						let params = {}
						params[keyTitle] = item.id
						res = await api.cvsEditor.deleteExtra(params)
					} else {
						// if(this.experienceList[type].length===1){
						//   //如果只剩下最后一个小模块，直接连带大模块一起删除
						//   res = await api.cvsEditor.deleteCustom(item.custom_section_id,{});
						// }else{
						//   }
						// 删除自定义小模块
						res = await api.cvsEditor.deleteCustomInfo(item.custom_section_id, item.id, {})
					}
					if (res.code === 1000) {
						if (!otherKey) {
							experienceList[type].splice(index, 1)
							backUpExperienceList[type].splice(index, 1)
							//自定义模块
							if (!experienceList[type].length) {
								if (!(type === 'edus' || type === 'works' || type === 'orgs' || type==='opus')) {
                  // let cvDetail = JSON.parse(JSON.stringify(this.cvDetail));
                  // let { sections_position, custom_sections_ids } = cvDetail.submodule_info;
                  // custom_sections_ids = custom_sections_ids.filter(i => i !== item.custom_section_id);
                  // cvDetail.submodule_info.custom_sections_ids = custom_sections_ids
                  // let data = {
                  //   operation_type:'update_submodule_info',
                  //   submodule_info: cvDetail.submodule_info
                  // }
                  // let updateCvRes = await api.cvsEditor.updatedCvInfo(this.cvToken, data)
                  // if (updateCvRes.code !== 1000) {
                  //   this.$message.error(updateCvRes.message)
                  //   return false
                  // }

                  // 自定义模块删除大模块有问题
									// // 执行删除大模块操作
									// let deleteCustomRes = await api.cvsEditor.deleteCustom(item.custom_section_id, {})
									// if (deleteCustomRes.code !== 1000) {
									// 	this.$message.error(deleteCustomRes.message)
									// 	return false
									// }
								}
								//删除vuex中的当前模块数据
								delete experienceList[type]
								delete backUpExperienceList[type]
								//删除当前的标题栏,更新到vuex中
								experienceTitleList.splice(this.currentExperienceType.index, 1)
                // if (!experienceTitleList.length) {
                //   this.updateSidebarOption('library')
                // }
								this.updateExperienceTitleList(experienceTitleList)
								//更新经历库数据
								this.updateExperienceList(experienceList)
								//更新经历库备份数据
								this.updateBackUpExperienceList(backUpExperienceList)
								//更新经历库tab到当前第0个
								this.updateCurrentExperienceType({ type: experienceTitleList[0].type, index: 0 })
							} else {
								//更新经历库数据
								this.updateExperienceList(experienceList)
								//更新经历库备份数据
								this.updateBackUpExperienceList(backUpExperienceList)
							}
						} else {
							experienceList[type][otherKey].splice(index, 1)
							backUpExperienceList[type][otherKey].splice(index, 1)
							//更新经历库数据
							this.updateExperienceList(experienceList)
							//更新经历库备份数据
							this.updateBackUpExperienceList(backUpExperienceList)

							// 检测是否经历库里，其他模块没有数据了
							let otherLength = 0
							Object.keys(experienceList[type]).forEach(otherKey => {
								otherLength += experienceList[type][otherKey].length
							})
							//没有数据了，删除当前标题
							if (!otherLength) {
								experienceTitleList = experienceTitleList.filter(item => item.type !== 'extras')
                // if (!experienceTitleList.length) {
                //   this.updateSidebarOption('library')
                // }
								this.updateExperienceTitleList(experienceTitleList)
								//更新当前选中项
								this.updateCurrentExperienceType({ type: experienceTitleList[0].type, index: 0 })
							}
						}
						// this.getMenuList()
            // setTimeout(async () => {
            //   await this.getCheckData({ needDealCheck: false, clickCheck: false })
            // },100)
						this.$message.success('删除成功')
					} else {
						this.$message.error(res.message)
						return false
					}
				} catch (error) {

				}
			},
			// 选择模块-除去other
			selectItem (item, index, type, experienceIndex) {
        let data = JSON.parse(JSON.stringify(item))
				//如果正在编辑，不能进行操作
				if (this.currentInfo.operation) {
					return false
				}
				let experienceList = JSON.parse(JSON.stringify(this.experienceList))
				// let { type } = this.currentExperienceType
        let experienceType = type || this.currentExperienceType.type
				if ((experienceType === 'skill_list' || experienceType === 'personal_summary') && !item.isSelect) {
					experienceList[experienceType].forEach(sitem => {
						sitem.isSelect = sitem.id === item.id
					})
				} else {
					experienceList[experienceType][index].isSelect = !item.isSelect
				}
        data.isSelect = !item.isSelect
        // 同步预览浮窗上面的数据
        this.setShowJobTabCardDialogData({data: data, type: type, index: index, bKey: '', experienceIndex})
				//同步选中数据
				this.updateExperienceList(experienceList)
        // 提交同步经历到简历中
        this.isMyselfResume && this.submit()
			},
			// 选择模块-other
			selectOther (bKey, item, index, type, experienceIndex) {
				//如果正在编辑，不能进行操作
				if (this.currentInfo.operation) {
					return false
				}
				let experienceList = JSON.parse(JSON.stringify(this.experienceList))
				// let { type } = this.currentExperienceType
        let experienceType = type || this.currentExperienceType.type
				if (item.isSelect) {
					experienceList[experienceType][bKey][index].isSelect = false
				} else {
					experienceList[experienceType][bKey].forEach(sitem => {
						sitem.isSelect = sitem.id === item.id
					})
				}
        // 同步预览浮窗上面的数据
        this.setShowJobTabCardDialogData({data: experienceList[experienceType][bKey][index], type: type, index: index, bKey: bKey, experienceIndex })
				// console.log(bKey, item, index)
				//同步选中数据
				this.updateExperienceList(experienceList)
        // 提交同步经历到简历中
        this.isMyselfResume && this.submit()
			},
      // 选中大牛经历分类职位
      toggleDniuJob(item, index) {
			  if (this.daniuCurrentExperienceType.id !== item.id) {
          document.getElementById('libraryScrollList').scrollTo({top: 0, left: 0, behavior: "auto"})
          this.updateDaniuCurrentType(item).then(() => {
            this.getDaniuExperienceList(this.cvDetail)
          })
        }
      },
      // 切换大牛经历module
      toggleModule(item, index) {
        document.getElementById('libraryScrollList').scrollTo({top: 0, left: 0, behavior: "auto"})
			  this.updateCurrentModule({ type: item.type, index })
        if (!this.daniuCurrentExperience.length) {
          this.getDaniuExperienceList(this.cvDetail)
        }
      },
			//切换tab
			toggleTab (item, index) {
				if (!this.currentInfo.operation) {
					this.updateCurrentExperienceType({ type: item.type, index })
				}
			},
			//filter选中数据
			filterItemCheck (list, itemType) {
				if (!list) {
					return []
				}
				if (itemType === 'extras') {
					let length = []
					for (let key in list) {
						length = length.concat(list[key].filter(item => item.isSelect))
					}
					return length
				} else {
					return list.filter(item => item.isSelect)
				}
			},
			// 保存
			submit () {
				if (this.isSubmit) return
				this.isSubmit = true
				let experienceList = JSON.parse(JSON.stringify(this.experienceList))
				let cvDetail = JSON.parse(JSON.stringify(this.cvDetail))
				let { submodule_info, submodule_info: { sections_position }, basic_info, basic_info: { kind, } } = cvDetail
				// 左侧数据需要的数据对象
				let cvDetailListObj = {}

				let experienceAllLength = this.getExperienceAllLength
				console.log('experienceAllLength=>>', experienceAllLength)
				//一个都没选择，不能提交
				if (!experienceAllLength && !this.isMyselfResume) {
					this.isSubmit = false
					return false
				}
				//循环经历库
				Object.keys(experienceList).forEach(key => {
					let item = experienceList[key]
					//当前模块选中的数据
					let selectItem = this.filterItemCheck(item, key)
					let cvHasModule = sections_position.filter(item => item.id === key || item.type === key).length
					if(key === 'opus'){
						return
					}
					if (key === 'edus' || key === 'works' || key === 'orgs') {
						// 当前模块选中的ids
						let selectItemIds = selectItem.map(item => item.id)
						// 用户简历中的ids
						let userKeyIds = experienceList[key].map(item => item.id)
						// 过滤掉简历库中没有的ids(sample数据)
						let sampleIds = submodule_info[key + '_ids'].filter(item => !userKeyIds.includes(item))
						// 过滤掉简历库中没有的(sample数据)
						// let sampleList = this[key].map(item => sampleIds.includes(item.id) ? item.id : '').filter(item => item)
						let sampleList = this[key].map(item => sampleIds.includes(item.id) ? item : '').filter(item => item)

						// 当前模块的ids = sampleIds + 经历库选中的id
						submodule_info[key + '_ids'] = sampleIds.concat(selectItemIds)
						//当前选中的模块，同步到左侧编辑数据中
						// cvDetailListObj[key] = selectItem;
						// 当前选中的模块，同步到左侧编辑数据中(其中包含sample数据)
						cvDetailListObj[key] = sampleList.concat(selectItem)
						//如果是大牛简历需要原有的数据和新的数据合并
						// if(kind === 'sample'){
						// }else{
						//   // 当前模块id = 选中的id
						//   submodule_info[key+'_ids'] = selectItemIds;
						// }

						//检测如果简历中没有此模块，需要动态添加进去
						if (!cvHasModule && selectItemIds.length) {
							sections_position.push({
								id: null,
								type: key,
								info_ids: []
							})
						}
					} else if (key === 'extras') {
						// let cvExtrasList = []
						let cvExtrasList = {}
						let checkExtras = 0
						Object.keys(item).forEach(keyItem => {
							let keyItemName = keyItem.substr(0, keyItem.length - 1)
							let ids = null
							item[keyItem].forEach(sitem => {
								if (sitem.isSelect) {
									//拿到当前小模块选中的id
									ids = sitem.id
									//把当前选中的小模块数据放在集合里，最终同步到简历数据里
									cvExtrasList[keyItemName] = sitem
								}
							})
							if (ids !== null) {
								checkExtras += 1
							}
							submodule_info[keyItemName + '_id'] = ids
						})
						//检测如果简历中没有此模块，需要动态添加进去
						if (!cvHasModule && checkExtras) {
							sections_position.push({
								id: null,
								type: 'extras',
								info_ids: []
							})
						}
						cvDetailListObj.extras = cvExtrasList
					} else {
						//拿到当前选中的经历库模块，检测是否在当前简历中， -1表示不存在
						let customIndex = sections_position.findIndex(item => (item.type == key || item.id == key))
						//从简历库标题列表中，拿到标题
						let customTitleItem = this.experienceTitleList.filter(item => item.type == key)
						// 当前模块选中的ids
						let selectItemIds = selectItem.map(item => item.id)
						// console.log('customTitleItem=>>',key,'=>>>',customTitleItem.length ?customTitleItem[0].title : '自定义')
						//经历库里选中了当前模块的数据
						if (selectItemIds.length) {
							// console.log(key, customIndex, sections_position)
							if (customIndex >= 0) {
								//如果有新id
								if (sections_position[customIndex].actionId) {
									//拿到老id及老id对应的标题
									let oldCustomId = sections_position[customIndex].id
									let oldCustomTitle = submodule_info.custom_sections_titles[oldCustomId + '_title']
									//找到老id在ids里的位置
									let oldCustomIdIndex = submodule_info.custom_sections_ids.findIndex(item => item === oldCustomId)

									// 删除标题里的老id
									delete submodule_info.custom_sections_titles[oldCustomId + '_title']
									// 把老id对应的标题，变为新id对应的标题
									submodule_info.custom_sections_titles[sections_position[customIndex].actionId + '_title'] = oldCustomTitle

									// 找到老的自定义id，替换为新的自定义id
									submodule_info.custom_sections_ids.splice(oldCustomIdIndex, 1, sections_position[customIndex].actionId)
								}
								//已经存在此模块，直接覆盖原有选中的模块ids
								sections_position[customIndex].info_ids = selectItemIds
								//把经历库里的相同模块的id，覆盖到大牛简历里的模块id
								sections_position[customIndex].id = sections_position[customIndex].actionId || sections_position[customIndex].id
							} else {
								//还不存在此模块，需要整理到简历里
								//取简历库当前模块里边的父级id
								let custom_section_id = selectItem[0].custom_section_id
								sections_position.push({
									id: custom_section_id,
									type: Number(key) > 0 ? 'custom' : key,
									info_ids: selectItemIds
								})
								//增加当前模块id到简历中
								submodule_info.custom_sections_ids.push(custom_section_id)
								submodule_info.custom_sections_ids = Array.from(new Set(submodule_info.custom_sections_ids))
								//增加当前模块名称到简历中
								submodule_info.custom_sections_titles[custom_section_id + '_title'] = customTitleItem.length ? customTitleItem[0].title : '自定义'
							}
							//当前选中的模块，同步到左侧编辑数据中
							cvDetailListObj[key] = selectItem
						} else if (customIndex >= 0) {
							//简历里有此模块，但是经历库里全部取消选中了
							//已经存在此模块，直接覆盖原有选中的模块ids
							sections_position[customIndex].info_ids = []

							//当前选中的模块，同步到左侧编辑数据中
							cvDetailListObj[key] = []
						}
					}
				})
				console.log('cvDetail=>>', cvDetail)
				// return false
				if (kind === 'template' || kind === 'sample') {
					basic_info.token = null
					basic_info.kind = null
					basic_info.updated_at = null
					basic_info.created_at = null

					//创建简历
					this.createCv({
						cvDetail, //简历数据
						experienceList, //经历库数据
						cvDetailListObj, //当前选中模块数据，需要整理到简历编辑vuex中
					})
				} else {
					//更新简历
					this.updateCv({
						cvDetail, //简历数据
						experienceList, //经历库数据
						cvDetailListObj, //当前选中模块数据，需要整理到简历编辑vuex中
					})
				}
				console.log('cvDetail=>>', cvDetail)
				this.isSubmit = false
			},
			//创建简历
			async createCv (options) {
				let { cvDetail, experienceList, cvDetailListObj } = options
				try {
					let res = await this.createCvDetail({
						payload: cvDetail
					})
					if (res.code === 1000) {
						//同步简历到vuex中
						this.setCvDetail(cvDetail)
						//更新备份经历库数据
						this.updateBackUpExperienceList(experienceList)
						//更新备份经历库数据
						this.updateBackUpExperienceList(experienceList)
						//经历库中选中模块数据，需要整理到简历编辑vuex中
						this.updateEditorData(cvDetailListObj)

						//更新模块管理选中模块
						this.getMenuList(cvDetail)
            setTimeout(async () => {
              await this.getCheckData({ needDealCheck: false, clickCheck: false })
            },100)
						// // 动态修改url
						// let newUrl = `${window.location.origin}/cvs/${res.data.basic_info.token}/editor`;
						// window.history.replaceState({}, 0, newUrl);
						//当前右侧大tab选择类型置为空
						this.updateSidebarOption('check')
						this.$message.success('创建成功')
					} else {
						this.$message.error(res.message)
					}
				} catch (error) {
					console.log(error)
					this.$message.error('创建失败')
				}
			},
			//更新简历
			async updateCv (options) {
				let { cvDetail, experienceList, cvDetailListObj } = options
				try {
					let data = {
						operation_type: 'update_submodule_info',
						submodule_info: cvDetail.submodule_info
					}
					let res = await api.cvsEditor.updatedCvInfo(this.cvToken, data)
					if (res.code === 1000) {
						//同步简历到vuex中
						this.setCvDetail(cvDetail)
						//更新备份经历库数据
						this.updateBackUpExperienceList(experienceList)
						//经历库中选中模块数据，需要整理到简历编辑vuex中
						this.updateEditorData(cvDetailListObj)
						//更新模块管理选中模块
						this.getMenuList(cvDetail)
            setTimeout(async () => {
              await this.getCheckData({ needDealCheck: false, clickCheck: false })
            },100)

						this.$message.success('更新成功')

						//当前右侧大tab选择类型置为空
						this.updateSidebarOption('check')
					} else {
						this.$message.error(res.message)
					}
				} catch (error) {
					console.log('error=>>', error)
					this.$message.error('更新失败')
				}
			},
			// 经历库中选中模块数据，需要整理到简历编辑vuex中
			updateEditorData (cvDetailListObj) {
				let { sections_position } = this.cvDetail.submodule_info
				let sectionsPositionKeys = sections_position.map(item => item.type === 'custom' ? (item.id ? String(item.id) : '') : (item.type || ''))
				console.log('sections_position=>>', sections_position)
				console.log('sectionsPositionKeys=>>', sectionsPositionKeys)
				Object.keys(cvDetailListObj).forEach(key => {
					let item = cvDetailListObj[key]
					// console.log(`updateEditorData key +>>>>> ${key}=>>>>>`,item)
					//循环更新vuex
					this.setModuleData({
						type: key,
						info: sectionsPositionKeys.includes(key) ? item : []
					})
				})
			}

		},
	}
</script>
<style lang="scss" scoped>
  // 公共初始化样式
  @import '~/assets/css/public';
  @import 'library';

</style>
<style>
  .active-title {
    color: #ff6644;
  }
</style>
